/* biome-ignore-all lint/complexity/noForEach: Dawn 標準コードは挙動維持のため変更しない */
/* section 再描画で script が再評価されても、トップレベル宣言と listener を重複させない */
(() => {
  const registeredFacetFiltersForm = customElements.get('facet-filters-form');
  const FacetFiltersForm =
    registeredFacetFiltersForm ||
    class FacetFiltersForm extends HTMLElement {
      constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
          this.onSubmitHandler(event);
        }, 800);

        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
      }

      static setListeners() {
        const onHistoryChange = (event) => {
          const searchParams = event.state
            ? event.state.searchParams
            : FacetFiltersForm.searchParamsInitial;
          const historyIndex = FacetFiltersForm.getHistoryIndex(event.state);
          if (searchParams === FacetFiltersForm.searchParamsPrev) {
            FacetFiltersForm.historyIndex = historyIndex;
            return;
          }
          FacetFiltersForm.renderPage(searchParams, null, false, historyIndex);
        };
        window.addEventListener('popstate', onHistoryChange);
      }

      static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
          element.classList.toggle('disabled', disable);
        });
      }

      static renderPage(searchParams, event, updateURLHash = true, targetHistoryIndex = null) {
        const normalizedParams =
          window.AuremePlp && typeof window.AuremePlp.normalizeSearchParams === 'function'
            ? window.AuremePlp.normalizeSearchParams(searchParams)
            : { searchParams, didChange: false };
        const nextSearchParams = normalizedParams.searchParams;
        const previousSearchParams = FacetFiltersForm.searchParamsPrev;
        const previousHistoryIndex = FacetFiltersForm.historyIndex;
        const renderToken = ++FacetFiltersForm.renderToken;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        const loadingSpinners = document.querySelectorAll(
          '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
        );
        loadingSpinners.forEach((spinner) => {
          spinner.classList.remove('hidden');
        });
        document
          .getElementById('ProductGridContainer')
          .querySelector('.collection')
          .classList.add('loading');
        if (countContainer) {
          countContainer.classList.add('loading');
        }
        if (countContainerDesktop) {
          countContainerDesktop.classList.add('loading');
        }

        const sectionRequests = sections.map((section) => {
          const querySuffix = nextSearchParams ? `&${nextSearchParams}` : '';
          const url = `${window.location.pathname}?section_id=${section.section}${querySuffix}`;
          const cachedSection = FacetFiltersForm.getCachedSection(url);

          return cachedSection
            ? FacetFiltersForm.renderSectionFromCache(cachedSection)
            : FacetFiltersForm.renderSectionFromFetch(url);
        });

        Promise.all(sectionRequests)
          .then((sectionData) => {
            if (renderToken !== FacetFiltersForm.renderToken) return;

            sectionData.forEach(({ html, url, fromCache }) => {
              if (!fromCache) {
                FacetFiltersForm.setCachedSection(url, html);
              }

              FacetFiltersForm.applySection(html, event);
            });

            FacetFiltersForm.searchParamsPrev = nextSearchParams;

            if (updateURLHash) {
              FacetFiltersForm.updateURLHash(nextSearchParams);
            } else if (targetHistoryIndex !== null) {
              if (normalizedParams.didChange) {
                FacetFiltersForm.replaceURLHash(nextSearchParams, targetHistoryIndex);
              } else {
                FacetFiltersForm.historyIndex = targetHistoryIndex;
              }
            } else if (normalizedParams.didChange) {
              FacetFiltersForm.replaceURLHash(nextSearchParams);
            }

            FacetFiltersForm.dispatchAuremeRenderEvent(nextSearchParams);
          })
          .catch((error) => {
            if (renderToken !== FacetFiltersForm.renderToken) return;

            if (
              window.AuremePlp &&
              typeof window.AuremePlp.clearQueuedFocusAfterRender === 'function'
            ) {
              window.AuremePlp.clearQueuedFocusAfterRender();
            }
            FacetFiltersForm.clearLoadingState();
            if (updateURLHash) {
              FacetFiltersForm.replaceURLHash(previousSearchParams);
            } else if (targetHistoryIndex !== null && targetHistoryIndex !== previousHistoryIndex) {
              history.go(previousHistoryIndex - targetHistoryIndex);
            }
            console.error(error);
            /* フィルター適用失敗をユーザーに通知 */
            window.AuremeToast?.show({
              message: 'フィルターの適用に失敗しました。\nページを再読み込みしてお試しください。',
              type: 'error',
            });
          });
      }

      /* フィルター、グリッド、カウントの再描画とイベント通知をまとめて行う */
      static applySection(html, event) {
        /* 同じHTML文字列を3回パースしないよう、一度だけDOMParserで変換して使い回す */
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        FacetFiltersForm.renderFilters(parsedHTML, event);
        FacetFiltersForm.renderProductGridContainer(parsedHTML);
        FacetFiltersForm.renderProductCount(parsedHTML);
        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(document.getElementById('ProductGridContainer'));
        }
        if (typeof initializeScrollZoomAnimationTrigger === 'function') {
          initializeScrollZoomAnimationTrigger(document.getElementById('ProductGridContainer'));
        }
      }

      /* フェッチ失敗時にローディング状態だけは必ず解除する */
      static clearLoadingState() {
        const productGridContainer = document.getElementById('ProductGridContainer');
        const collection = productGridContainer
          ? productGridContainer.querySelector('.collection')
          : null;
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        const loadingSpinners = document.querySelectorAll(
          '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
        );

        if (collection) {
          collection.classList.remove('loading');
        }

        if (countContainer) {
          countContainer.classList.remove('loading');
        }

        if (countContainerDesktop) {
          countContainerDesktop.classList.remove('loading');
        }

        loadingSpinners.forEach((spinner) => {
          spinner.classList.add('hidden');
        });
      }

      static renderSectionFromFetch(url) {
        return fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Failed to fetch section: ${response.status}`);
            }

            return response.text();
          })
          .then((html) => ({ html, url, fromCache: false }));
      }

      static renderSectionFromCache(cachedSection) {
        return {
          html: cachedSection.html,
          url: cachedSection.url,
          fromCache: true,
        };
      }

      static getCachedSection(url) {
        if (!FacetFiltersForm.filterData.has(url)) return null;

        const cachedSection = FacetFiltersForm.filterData.get(url);
        /* 古い順に破棄する仕組みを維持するため、使用したキーを末尾へ移動する */
        FacetFiltersForm.filterData.delete(url);
        FacetFiltersForm.filterData.set(url, cachedSection);
        return cachedSection;
      }

      static setCachedSection(url, html) {
        if (FacetFiltersForm.filterData.has(url)) {
          FacetFiltersForm.filterData.delete(url);
        }

        FacetFiltersForm.filterData.set(url, { html, url });

        while (FacetFiltersForm.filterData.size > FacetFiltersForm.MAX_FILTER_CACHE_ENTRIES) {
          const oldestCacheKey = FacetFiltersForm.filterData.keys().next().value;
          FacetFiltersForm.filterData.delete(oldestCacheKey);
        }
      }

      static renderProductGridContainer(parsedHTML) {
        const container = document.getElementById('ProductGridContainer');
        container.innerHTML = parsedHTML.getElementById('ProductGridContainer').innerHTML;

        container.querySelectorAll('.scroll-trigger').forEach((element) => {
          element.classList.add('scroll-trigger--cancel');
        });
      }

      static renderProductCount(parsedHTML) {
        const count = parsedHTML.getElementById('ProductCount').innerHTML;
        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        container.innerHTML = count;
        container.classList.remove('loading');
        if (containerDesktop) {
          containerDesktop.innerHTML = count;
          containerDesktop.classList.remove('loading');
        }
        const loadingSpinners = document.querySelectorAll(
          '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
        );
        loadingSpinners.forEach((spinner) => {
          spinner.classList.add('hidden');
        });
      }

      static cleanupAuremePlpDrawerState(root) {
        if (!root) return;

        const isFilterOpen = root.classList.contains('is-filter-open');
        const hasBodyScrollLock = document.body.classList.contains('aureme-plp-filter-open');

        if (!isFilterOpen && !hasBodyScrollLock) return;

        const filterTrigger = root.querySelector('[data-aureme-filter-trigger]');

        root.classList.remove('is-filter-open');
        document.body.classList.remove('aureme-plp-filter-open');
        filterTrigger?.setAttribute('aria-expanded', 'false');

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus();
        }
      }

      static renderFilters(parsedHTML, event) {
        const auremeFacetRootFromFetch = parsedHTML.querySelector('[data-aureme-plp-root]');
        const auremeFacetRootFromDom = document.querySelector('[data-aureme-plp-root]');

        if (auremeFacetRootFromFetch && auremeFacetRootFromDom) {
          /* PLP root 差し替え前にドロワー由来の scroll lock と focus trap を必ず解除する */
          FacetFiltersForm.cleanupAuremePlpDrawerState(auremeFacetRootFromDom);
          auremeFacetRootFromDom.outerHTML = auremeFacetRootFromFetch.outerHTML;
          return;
        }

        const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
          '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
        );
        const facetDetailsElementsFromDom = document.querySelectorAll(
          '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
        );

        /* サーバーから返されなくなったファセットを DOM から除去する */
        Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
          if (
            !Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)
          ) {
            currentElement.remove();
          }
        });

        const matchesId = (element) => {
          const jsFilter = event ? event.target.closest('.js-filter') : undefined;
          return jsFilter ? element.id === jsFilter.id : false;
        };

        const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
          (element) => !matchesId(element),
        );
        const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

        facetsToRender.forEach((elementToRender, index) => {
          const currentElement = document.getElementById(elementToRender.id);
          /* DOM に既に存在する要素は innerHTML だけ更新する */
          if (currentElement) {
            document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
          } else {
            if (index > 0) {
              const { className: previousElementClassName, id: previousElementId } =
                facetsToRender[index - 1];
              /* 同じファセット種別（例: horizontal/vertical, drawer/mobile）なら直後に挿入する */
              if (elementToRender.className === previousElementClassName) {
                document.getElementById(previousElementId).after(elementToRender);
                return;
              }
            }

            if (elementToRender.parentElement) {
              document
                .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
                .before(elementToRender);
            }
          }
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) {
          const closestJSFilterID = event.target.closest('.js-filter').id;

          if (closestJSFilterID) {
            FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
            FacetFiltersForm.renderMobileCounts(
              countsToRender,
              document.getElementById(closestJSFilterID),
            );

            const newFacetDetailsElement = document.getElementById(closestJSFilterID);
            const newElementSelector = newFacetDetailsElement.classList.contains(
              'mobile-facets__details',
            )
              ? `.mobile-facets__close-button`
              : `.facets__summary`;
            const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

            const isTextInput = event.target.getAttribute('type') === 'text';

            if (newElementToActivate && !isTextInput) newElementToActivate.focus();
          }
        }
      }

      static renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

        activeFacetElementSelectors.forEach((selector) => {
          const activeFacetsElement = html.querySelector(selector);
          if (!activeFacetsElement) return;
          document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });

        FacetFiltersForm.toggleActiveFacets(false);
      }

      static renderAdditionalElements(html) {
        if (document.querySelector('[data-aureme-plp-root]')) return;

        const mobileElementSelectors = [
          '.mobile-facets__open',
          '.mobile-facets__count',
          '.sorting',
        ];

        mobileElementSelectors.forEach((selector) => {
          const sourceElements = html.querySelectorAll(selector);
          const targetElements = document.querySelectorAll(selector);
          if (!sourceElements.length || !targetElements.length) return;

          targetElements.forEach((targetElement, index) => {
            const sourceElement = sourceElements[index];
            if (!sourceElement) return;
            targetElement.innerHTML = sourceElement.innerHTML;
          });
        });

        const mobileForm = document.getElementById('FacetFiltersFormMobile');
        const mobileDrawer = mobileForm?.closest('menu-drawer');
        if (mobileDrawer) mobileDrawer.bindEvents();
      }

      static renderCounts(source, target) {
        const targetSummary = target.querySelector('.facets__summary');
        const sourceSummary = source.querySelector('.facets__summary');

        if (sourceSummary && targetSummary) {
          targetSummary.outerHTML = sourceSummary.outerHTML;
        }

        const targetHeaderElement = target.querySelector('.facets__header');
        const sourceHeaderElement = source.querySelector('.facets__header');

        if (sourceHeaderElement && targetHeaderElement) {
          targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
        }

        const targetWrapElement = target.querySelector('.facets-wrap');
        const sourceWrapElement = source.querySelector('.facets-wrap');

        if (sourceWrapElement && targetWrapElement) {
          const isShowingMore = Boolean(
            target.querySelector('show-more-button .label-show-more.hidden'),
          );
          if (isShowingMore) {
            sourceWrapElement.querySelectorAll('.facets__item.hidden').forEach((hiddenItem) => {
              hiddenItem.classList.replace('hidden', 'show-more-item');
            });
          }

          targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
        }
      }

      static renderMobileCounts(source, target) {
        const targetFacetsList = target.querySelector('.mobile-facets__list');
        const sourceFacetsList = source.querySelector('.mobile-facets__list');

        if (sourceFacetsList && targetFacetsList) {
          targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
        }
      }

      static updateURLHash(searchParams) {
        const nextHistoryIndex = FacetFiltersForm.historyIndex + 1;
        history.pushState(
          FacetFiltersForm.buildHistoryState(searchParams, nextHistoryIndex),
          '',
          FacetFiltersForm.buildUrl(searchParams),
        );
        FacetFiltersForm.historyIndex = nextHistoryIndex;
      }

      static replaceURLHash(searchParams, historyIndex = FacetFiltersForm.historyIndex) {
        history.replaceState(
          FacetFiltersForm.buildHistoryState(searchParams, historyIndex),
          '',
          FacetFiltersForm.buildUrl(searchParams),
        );
        FacetFiltersForm.historyIndex = historyIndex;
      }

      static buildUrl(searchParams) {
        return `${window.location.pathname}${searchParams ? '?'.concat(searchParams) : ''}`;
      }

      static buildHistoryState(searchParams, historyIndex) {
        const currentState =
          history.state && typeof history.state === 'object' ? history.state : {};
        return {
          ...currentState,
          searchParams,
          auremePlpHistoryIndex: historyIndex,
        };
      }

      static getHistoryIndex(state = history.state) {
        if (state && typeof state.auremePlpHistoryIndex === 'number') {
          return state.auremePlpHistoryIndex;
        }

        return 0;
      }

      static dispatchAuremeRenderEvent(searchParams = '') {
        if (!document.querySelector('[data-aureme-plp-root]')) return;
        document.dispatchEvent(
          new CustomEvent('aureme:plp:rendered', {
            detail: {
              searchParams,
            },
          }),
        );
      }

      static getSections() {
        return [
          {
            section: document.getElementById('product-grid').dataset.id,
          },
        ];
      }

      createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
      }

      onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        if (event.target.className === 'mobile-facets__checkbox') {
          const searchParams = this.createSearchParams(event.target.closest('form'));
          this.onSubmitForm(searchParams, event);
        } else {
          const forms = [];
          const currentFormId = event.target.closest('form').id;
          const isMobile =
            currentFormId === 'FacetFiltersFormMobile' || currentFormId === 'FacetSortMobileForm';

          sortFilterForms.forEach((form) => {
            if (!isMobile) {
              if (
                form.id === 'FacetSortForm' ||
                form.id === 'FacetFiltersForm' ||
                form.id === 'FacetSortDrawerForm'
              ) {
                forms.push(this.createSearchParams(form));
              }
            } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortMobileForm') {
              forms.push(this.createSearchParams(form));
            }
          });
          this.onSubmitForm(forms.join('&'), event);
        }
      }

      onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
          event.currentTarget.href.indexOf('?') === -1
            ? ''
            : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
      }
    };

  if (!registeredFacetFiltersForm) {
    FacetFiltersForm.MAX_FILTER_CACHE_ENTRIES = 20;
    FacetFiltersForm.filterData = new Map();
    FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
    FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
    FacetFiltersForm.historyIndex = FacetFiltersForm.getHistoryIndex(history.state);
    FacetFiltersForm.replaceURLHash(
      FacetFiltersForm.searchParamsPrev,
      FacetFiltersForm.historyIndex,
    );
    FacetFiltersForm.renderToken = 0;
    customElements.define('facet-filters-form', FacetFiltersForm);
    FacetFiltersForm.setListeners();
  }

  window.FacetFiltersForm = FacetFiltersForm;

  if (!customElements.get('price-range')) {
    customElements.define(
      'price-range',
      class PriceRange extends HTMLElement {
        constructor() {
          super();
          this.querySelectorAll('input').forEach((element) => {
            element.addEventListener('change', this.onRangeChange.bind(this));
            element.addEventListener('keydown', this.onKeyDown.bind(this));
          });
          this.setMinAndMaxValues();
        }

        onRangeChange(event) {
          this.adjustToValidValues(event.currentTarget);
          this.setMinAndMaxValues();
        }

        onKeyDown(event) {
          if (event.metaKey) return;

          const pattern =
            /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
          if (!event.key.match(pattern)) event.preventDefault();
        }

        setMinAndMaxValues() {
          const inputs = this.querySelectorAll('input');
          const minInput = inputs[0];
          const maxInput = inputs[1];
          if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
          if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
          if (minInput.value === '') maxInput.setAttribute('data-min', 0);
          if (maxInput.value === '')
            minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
        }

        adjustToValidValues(input) {
          const value = Number(input.value);
          const min = Number(input.getAttribute('data-min'));
          const max = Number(input.getAttribute('data-max'));

          if (value < min) input.value = min;
          if (value > max) input.value = max;
        }
      },
    );
  }

  if (!customElements.get('facet-remove')) {
    customElements.define(
      'facet-remove',
      class FacetRemove extends HTMLElement {
        constructor() {
          super();
          const facetLink = this.querySelector('a');
          facetLink.setAttribute('role', 'button');
          facetLink.addEventListener('click', this.closeFilter.bind(this));
          facetLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
          });
        }

        closeFilter(event) {
          event.preventDefault();
          const form =
            this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
          form.onActiveFilterClick(event);
        }
      },
    );
  }
})();
